import { render } from "./PageNotFound.vue?vue&type=template&id=2015e6c1&scoped=true"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=2015e6c1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2158973318/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2015e6c1"]])

export default __exports__